import { PrimitiveType } from "intl-messageformat";
import { createIntl, createIntlCache } from "react-intl";
import { generalStore } from "../stores/GeneralStore";
import { ILocales } from "./ILocales";
import german from "./de.json";
import english from "./en.json";

type IMessages = {
    [locale in ILocales]: {
        [message: string]: string;
    };
};

const DEFAULT_LOCALE = "de";

const intlMessages: IMessages = {
    en: english,
    de: german,
};

const cache = createIntlCache();

let intl = createIntl(
    {
        locale: DEFAULT_LOCALE,
        messages: intlMessages[generalStore.locale],
    },
    cache,
);

export type IMessageIDS = keyof typeof german;

const setLocale = (locale: ILocales) => {
    intl = createIntl(
        {
            locale: locale,
            messages: intlMessages[locale],
        },
        cache,
    );

    generalStore.locale = locale;
    document.documentElement.lang = locale;

    console.log(`%cSet locale to "${locale}".`, "background: #eee; color: #666;");
};

const t = (messageId: IMessageIDS, values?: Record<string, PrimitiveType>) => {
    return intl.formatMessage({ id: messageId }, values);
};

export { intl, intlMessages, setLocale, t };
